import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=7d109180&scoped=true&"
import script from "./UsersDetails.vue?vue&type=script&lang=js&"
export * from "./UsersDetails.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=7d109180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d109180",
  null
  
)

export default component.exports